import { IBaseCompany, ICompany } from 'types/income';
import { convertBaseCompany, convertCompany } from 'store/companies';
import { loaders } from './admin-companies.loaders';
import { AdminBaseCompany, AdminCompany } from './admin-companies.types';

export const convertAdminBaseCompany = (
  company: IBaseCompany,
): AdminBaseCompany => {
  return {
    ...convertBaseCompany(company),
  };
};

export const convertAdminBaseCompanies = (
  companies: IBaseCompany[],
): AdminBaseCompany[] => {
  return companies.map(convertAdminBaseCompany);
};

const convertAdminCompany = (company: ICompany): AdminCompany => {
  return {
    ...convertCompany(company),
  };
};

export const converters = {
  getCompanies: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCompanies>>) => {
    const items = convertAdminBaseCompanies(data.data);

    return {
      items,
      total: items.length,
    };
  },
  getCompany: ({ data }: Awaited<ReturnType<typeof loaders.getCompany>>) => {
    return convertAdminCompany(data);
  },
};
